export default __webpack_public_path__ + "static/media/top-bg-mobile.67296705.svg";